import React, {PureComponent} from 'react';

class QueryTypeIndicator extends PureComponent {
    render() {
        const { className, label } = lookupType(this.props.type);
        return (
            <div className={className}>{label}</div>
        );
    }
}

function lookupType(type) {
    switch (type) {
    case 'QUERY':
        return {
            className: 'query-type query-type-query',
            label: 'Q'
        };
    case 'MUTATION':
        return {
            className: 'query-type query-type-mutation',
            label: 'M'
        };
    default:
        throw new Error('Invalid type');
    }
}

export default QueryTypeIndicator;



// WEBPACK FOOTER //
// ./src/components/QueryTypeIndicator.js